/**
 * navlog — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/navlog.ts`.
 */

export const navlog = {
  /* route rows */
  'leg.freq': 'VOR/NDB-Frequenz',
  'leg.safealt': 'Sicherheitshöhe',
  'leg.alt': 'geplante Flughöhe/FL',
  'leg.tas': 'VE/TAS',
  'leg.wind': 'Wind W/V',
  'leg.tc': 'rechtweisender Kurs (rwK)',
  'leg.wca': 'Luvwinkel (WCA)',
  'leg.var': 'Mißweisung (VAR)',
  'leg.mh': 'mißweisender Steuerkurs (mwSK)',
  'leg.mc': 'mißweisender Kurs (mwK)',
  'leg.dist': 'Entfernung Abschnitt',
  'leg.rest_dist': 'Entfernung Rest',
  'leg.gs': 'Geschwindigkeit über Grund (GS)',
  'leg.time': 'Zeit Abschnitt',
  'leg.rest_time': 'Zeit Rest',
  'leg.remark': 'Bemerkungen/Frequenzen',

  /* checkpoints */
  'cp.name': 'Kontrollpunkt',
  'cp.freq': 'VOR/NDB-Frequenz',
  'cp.eto': 'ETO – voraussichtliche Überflugzeit',
  'cp.ato': 'ATO – tatsächliche Überflugzeit',
  'th.cp': 'Kontrollpunkt',
  'th.vor': 'VOR/NDB',
  'th.safealt': 'Sicherheitshöhe',
  'th.alt': 'Höhe/FL',
  'th.tas': 'TAS',
  'th.wind': 'Wind',
  'th.tc': 'rwK',
  'th.var': 'VAR',
  'th.wca': 'WCA',
  'th.mh': 'mwSK',
  'th.mc': 'mwK',
  'th.dist': 'NM',
  'th.rest_dist': 'Rest',
  'th.gs': 'GS',
  'th.time': 'min',
  'th.rest_time': 'Rest',
  'th.eto': 'ETO',
  'th.ato': 'ATO',
  'th.remark': 'Bemerkungen',

  /* the NavLog's own columns */
  'th.sh': 'SH',
  'th.leg': 'Abschnitt',
  'th.fromto': 'Von → Nach',
  'th.fuel': 'Kraftstoff',

  /* what a cell says about itself */
  'navlog.computed': 'berechnet',
  'navlog.override': 'von Ihnen überschrieben',
  'navlog.row.alt': 'A',
  'navlog.alt.wind': 'Für den Ausweichflugplatz holt Aether keinen Wind.',
  'navlog.legend': 'Blaue Werte rechnet Aether. Tippen Sie darüber, dann gehören sie Ihnen.',

  'navlog.empty.title': 'Noch keine Abschnitte.',
  'navlog.empty.line': 'Zeichnen Sie die Strecke auf der Karte oder suchen Sie einen Flugplatz.',
  'navlog.empty.action': 'Flugplatz suchen',

  'navlog.title': 'NavLog',
} as const;
